import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { WhoItsForSection } from './components/WhoItsForSection';
import { ProblemSection } from './components/ProblemSection';
import { ProductShowcaseSection } from './components/ProductShowcaseSection';
import { SocialProofSection } from './components/SocialProofSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
export function App() {
  useEffect(() => {
    // Manual Meta Pixel initialization
    const pixelId = '938923762400826';
    // Initialize fbq
    if (!(window as any).fbq) {
      const n = ((window as any).fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      }) as any;
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
    }
    // Load the pixel script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    (window as any).fbq('init', pixelId);
    (window as any).fbq('track', 'PageView');
    return () => {
      // Cleanup script on unmount
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);
  return <div className="min-h-screen bg-tcp-pure-black text-white font-body selection:bg-tcp-red selection:text-white overflow-x-hidden" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <WhoItsForSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <ProductShowcaseSection data-id="element-5" />
        <SocialProofSection data-id="element-6" />
        <FAQSection data-id="element-7" />
        <FinalCTASection data-id="element-8" />
      </main>

      {/* Minimal Footer */}
      <footer className="bg-tcp-pure-black border-t-2 border-tcp-red py-12" data-id="element-9">
        <div className="container mx-auto px-6 max-w-7xl flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-10">
          <div data-id="element-11">
            <h5 className="font-display text-xl font-bold text-white mb-1 text-center" data-id="element-12">
              The Christmas Palace
            </h5>
            <p className="text-gray-500 text-sm" data-id="element-13">
              Premium Wholesale Décor • Founded 1992
            </p>
          </div>

          <div className="text-gray-500 text-sm" data-id="element-14">
            <a href="#" className="hover:text-tcp-red transition-colors duration-300" data-id="element-15">
              wholesale.thechristmaspalace.com
            </a>
          </div>
        </div>
      </footer>
    </div>;
}